import InputPreview from './Layout.vue'

export default InputPreview
